import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import { checkFont } from '../func';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    text: {
      fontSize: attributes.style?.fontSize || 14,
      color: attributes.style?.color || 'rgba(26, 39, 55, 1)',
      fontFamily: checkFont(
        attributes.style?.fontFamily || attributes.fontFamily
      ),
    },
    wrapper: {
      ...pick(attributes, [
        'opacity',
        'width',
        'marginTop',
        'marginLeft',
        'borderRadius',
        'height',
      ]),
      // Override with style object properties if they exist
      ...(attributes.style?.opacity !== undefined && {
        opacity: attributes.style.opacity,
      }),
      ...(attributes.style?.width && { width: attributes.style.width }),
      ...(attributes.style?.height && { height: attributes.style.height }),
      ...(attributes.style?.marginTop !== undefined && {
        marginTop: attributes.style.marginTop,
      }),
      ...(attributes.style?.marginLeft !== undefined && {
        marginLeft: attributes.style.marginLeft,
      }),
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      ...((attributes.style?.borderStyle || attributes.borderStyle) !== 'none'
        ? {
            borderWidth:
              attributes.style?.borderWidth || attributes.borderWidth,
            borderColor:
              attributes.style?.borderColor || attributes.borderColor,
          }
        : {}),
      borderStyle:
        (attributes.style?.borderStyle || attributes.borderStyle) === 'none'
          ? 'solid'
          : attributes.style?.borderStyle || attributes.borderStyle,
      borderRadius:
        attributes.style?.borderRadius || attributes.borderRadius || 100,
      backgroundColor:
        attributes.style?.backgroundColor || 'rgb(228, 234, 238)',
      // height: 42,
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
    trigger: {
      flex: 1,
    },
    innerView: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    fileWrapper: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    filename: {},
    filenameText: {
      textAlign: 'center',
    },
    clearButton: {
      marginTop: 10,
    },
    clearText: {
      color: '#8a8a8a',
      fontWeight: '500',
      fontSize: 12,
    },
    loaderWrapper: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
};

export default createStyles;
